import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";

export default function MobileMenu({ isMobileMenu, handleMobileMenu }) {
	const location = useLocation();
	const [currentMenuItem, setCurrentMenuItem] = useState("");
	const [isAccordion, setIsAccordion] = useState(null);

	const handleAccordion = (key) => {
		setIsAccordion((prev) => (prev === key ? null : key));
	};

	useEffect(() => {
		setCurrentMenuItem(location.pathname);
	}, [location.pathname]);

	const checkCurrentMenuItem = (path) =>
		currentMenuItem === path ? "current-menu-item" : "";

	const checkParentActive = (paths = []) =>
		paths.some((path) => currentMenuItem.startsWith(path))
			? "current-menu-item"
			: "";

	return (
		<>
			{/* nav container */}
			<nav
				id="mainnav-mobi"
				className={`mainnav style1 ${isMobileMenu ? "active" : ""}`}
			>
				<div id="logo-mobie" className="logo">
					{/* Mobile logo - update if needed */}
					<Link to="/" rel="home">
						<img src="/images/logo.png" alt="logo" />
					</Link>
				</div>
				<ul className="menu">
					{/* HOME */}
					<li className={checkCurrentMenuItem("/")}>
						<Link to="/" onClick={handleMobileMenu}>
							Home
						</Link>
					</li>

					{/* CONTACT */}
					<li className={checkCurrentMenuItem("/contact")}>
						<Link to="/contact" onClick={handleMobileMenu}>
							Contact Us
						</Link>
					</li>
				</ul>
			</nav>

			{/* Overlay that closes the menu when clicked */}
			<div
				className={`overlay-menu-mobie ${isMobileMenu ? "active" : ""}`}
				onClick={handleMobileMenu}
			>
				<div className="close-btn">
					<span className="close-menus" />
				</div>
			</div>
		</>
	);
}



// // 
// 					{/* TFD SELECT */}
// 					<li className={`${checkParentActive(["/tfd-select"])}`}>
// 						<Link to="/tfd-select" onClick={handleMobileMenu}>
// 							TFD SELECT
// 						</Link>
// 						{/* Accordion toggle */}
// 						<span className="btn-submenu" onClick={() => handleAccordion(1)} />
// 						<ul
// 							className="submenu"
// 							style={{ display: isAccordion === 1 ? "block" : "none" }}
// 						>
// 							<li className={checkCurrentMenuItem("/tfd-select/academy")}>
// 								<Link to="/tfd-select/academy" onClick={handleMobileMenu}>
// 									Academy
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem("/tfd-select/private-sessions")}
// 							>
// 								<Link
// 									to="/tfd-select/private-sessions"
// 									onClick={handleMobileMenu}
// 								>
// 									Private Sessions
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-select/perth-champions-league"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-select/perth-champions-league"
// 									onClick={handleMobileMenu}
// 								>
// 									Perth Champions League
// 								</Link>
// 							</li>
// 							<li className={checkCurrentMenuItem("/tfd-select/camps")}>
// 								<Link to="/tfd-select/camps" onClick={handleMobileMenu}>
// 									Camps
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem("/tfd-select/national-tours")}
// 							>
// 								<Link
// 									to="/tfd-select/national-tours"
// 									onClick={handleMobileMenu}
// 								>
// 									National Tours
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-select/international-tours"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-select/international-tours"
// 									onClick={handleMobileMenu}
// 								>
// 									International Tours
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem("/tfd-select/player-history")}
// 							>
// 								<Link
// 									to="/tfd-select/player-history"
// 									onClick={handleMobileMenu}
// 								>
// 									Player History
// 								</Link>
// 							</li>
// 							<li className={checkCurrentMenuItem("/tfd-select/meet-the-team")}>
// 								<Link to="/tfd-select/meet-the-team" onClick={handleMobileMenu}>
// 									Meet the Team
// 								</Link>
// 							</li>
// 						</ul>
// 					</li>

// 					{/* TFD ACCELERATE */}
// 					<li className={`${checkParentActive(["/tfd-accelerate"])}`}>
// 						<Link to="/tfd-accelerate" onClick={handleMobileMenu}>
// 							TFD ACCELERATE
// 						</Link>
// 						<span className="btn-submenu" onClick={() => handleAccordion(2)} />
// 						<ul
// 							className="submenu"
// 							style={{ display: isAccordion === 2 ? "block" : "none" }}
// 						>
// 							<li className={checkCurrentMenuItem("/tfd-accelerate/academy")}>
// 								<Link to="/tfd-accelerate/academy" onClick={handleMobileMenu}>
// 									Academy
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-accelerate/private-sessions"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-accelerate/private-sessions"
// 									onClick={handleMobileMenu}
// 								>
// 									Private Sessions
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-accelerate/perth-europa-league"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-accelerate/perth-europa-league"
// 									onClick={handleMobileMenu}
// 								>
// 									Perth Europa League
// 								</Link>
// 							</li>
// 							<li className={checkCurrentMenuItem("/tfd-accelerate/camps")}>
// 								<Link to="/tfd-accelerate/camps" onClick={handleMobileMenu}>
// 									Camps
// 								</Link>
// 							</li>
// 							<li className={checkCurrentMenuItem("/tfd-accelerate/schools")}>
// 								<Link to="/tfd-accelerate/schools" onClick={handleMobileMenu}>
// 									Schools
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-accelerate/little-superstars"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-accelerate/little-superstars"
// 									onClick={handleMobileMenu}
// 								>
// 									Little Superstars
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-accelerate/national-tours"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-accelerate/national-tours"
// 									onClick={handleMobileMenu}
// 								>
// 									National Tours
// 								</Link>
// 							</li>
// 							<li
// 								className={checkCurrentMenuItem(
// 									"/tfd-accelerate/international-experience"
// 								)}
// 							>
// 								<Link
// 									to="/tfd-accelerate/international-experience"
// 									onClick={handleMobileMenu}
// 								>
// 									International Experience
// 								</Link>
// 							</li>
// 						</ul>
// 					</li>
